import { useQuery } from '@tanstack/react-query';
import { QueryKeys } from '../../../shared/constants';
import { getSMSTemplateTypes } from '../../../shared/services';
const useGetSMSTemplateTypes = () => {
    return useQuery({
        queryKey: [QueryKeys.GetSMSTemplateTypes],
        queryFn: async () => {
            const { data } = await getSMSTemplateTypes();
            return data;
        },
        select: (data) => ({
            notificationTypes: data?.notification_type || [],
            types: data?.type || [],
        }),
    });
};
export default useGetSMSTemplateTypes;
